import { ProductPlantsActions, RESET, LOAD_OWNFREIGHT_PLANTS_COMPLETE } from '../../actions/product-plants.actions';
import { Plant } from '@cemex-core/cmx-api';

export interface OwfreightPlantsState {
  availablePlants: {
    [productId: number]: Plant[];
  };
}

export const initialState: OwfreightPlantsState = {
  availablePlants: {},
};

export function ownfreightPlantsReducer(state = initialState, action: ProductPlantsActions): OwfreightPlantsState {
  switch (action.type) {
    case LOAD_OWNFREIGHT_PLANTS_COMPLETE: {
      return {
        ...state,
        availablePlants: {
          ...state.availablePlants,
          [action.payload.productId]: action && action.payload && action.payload.plants,
        },
      };
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
